import { render, staticRenderFns } from "./BroadcastProgramView.vue?vue&type=template&id=38402d0e&"
import script from "./BroadcastProgramView.vue?vue&type=script&lang=js&"
export * from "./BroadcastProgramView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports